import React from "react";
import PhotosUploader from "./PhotosUploader";

export const UserPhotosManager = () => {
  return (
    <>
      <PhotosUploader />
    </>
  );
};
